'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dEnvelopes$002dPage$0024 from "./presto.-List-Envelopes-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024103 from "./presto.-Presto-Router$$anon$103.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$102() {
  this.bdi = null;
  this.bda = null;
  this.bdb = false;
  this.bdj = null;
  this.bdk = false;
  this.bdn = null;
  this.bdg = null;
  this.bdh = false;
  this.bdc = null;
  this.bdd = false;
  this.bde = null;
  this.bdf = false;
  this.bdl = false;
  this.bdm = false;
  this.bdi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bdn = "ListEnvelopesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$102 as $c_Lpresto_PrestoRouter$$anon$102 };
$p = $c_Lpresto_PrestoRouter$$anon$102.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$102;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$102() {
}
export { $h_Lpresto_PrestoRouter$$anon$102 as $h_Lpresto_PrestoRouter$$anon$102 };
$h_Lpresto_PrestoRouter$$anon$102.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bdi;
});
$p.L = (function() {
  if ((!this.bdb)) {
    this.bda = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bdb = true;
  }
  return this.bda;
});
$p.O = (function() {
  if ((!this.bdk)) {
    this.bdj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bdk = true;
  }
  return this.bdj;
});
$p.E = (function() {
  return this.bdn;
});
$p.t = (function() {
  if ((!this.bdh)) {
    this.bdg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bdh = true;
  }
  return this.bdg;
});
$p.M = (function() {
  if ((!this.bdd)) {
    this.bdc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bdd = true;
  }
  return this.bdc;
});
$p.Q = (function() {
  if ((!this.bdf)) {
    this.bde = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024103.$c_Lpresto_PrestoRouter$$anon$103();
    this.bdf = true;
  }
  return this.bde;
});
$p.w = (function() {
  if ((!this.bdm)) {
    this.bdl = false;
    this.bdm = true;
  }
  return this.bdl;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee618) => ((p) => \u03b4scrutinee618))($j_presto$002e$002dList$002dEnvelopes$002dPage$0024.$m_Lpresto_ListEnvelopesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$102 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$102, "presto.PrestoRouter$$anon$102", ({
  Nq: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$102 as $d_Lpresto_PrestoRouter$$anon$102 };
//# sourceMappingURL=presto.-Presto-Router$$anon$102.js.map
